import React from 'react'

const ApiErrorView = ({ apiError }) => !apiError ? null : (
	<div style={{ backgroundColor: '#e53935', padding: 16, margin: 8, color: 'white'}}>
		{apiError.localizedMessage || apiError.message}
	</div>
)

export default ApiErrorView